import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHead } from "./SectionHead";
import { workshops } from "../data/landing";
export function WorkshopsSection() {
  return <section id="workshops" className="bg-white py-16 md:py-24" data-id="element-183" data-mp="16qe1o4zj8k1s">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-184" data-mp="16qxo9z04nwm5">
        <SectionHead eyebrow={`Volume 01 · ${workshops.length} workshops`} title="Ten everyday challenges." highlight="Ten prepared workshops." lead="Run them individually when a need comes up, or follow the sequence as a ten-session manager development program." data-id="element-185" data-mp="1bo659w9jhult" />
        <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-186" data-mp="nyv1e5ww7k3g">
          {workshops.map((w, i) => <li key={w.title} className="flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-[0_10px_30px_rgba(19,34,56,0.07)]" data-id="element-187" data-mp="sro6iuw9wug2" data-mpi={i}>
              <div className="relative flex h-32 flex-col justify-between border-l-[8px] border-navy-deep bg-navy p-4" data-id="element-188" data-mp="89499offk88">
                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/70" data-id="element-189" data-mp="1svui6v1el2hu">Workshop</span>
                <span className="font-display text-[56px] font-extrabold leading-[0.8] text-teal-bright" data-id="element-190" data-mp="1k1pv8mpe4b7l">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute right-4 top-4 text-[10px] font-bold tracking-[0.12em] text-teal-bright" data-id="element-191" data-mp="1f0ingnn8zc0x">
                  60 MIN
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4" data-id="element-192" data-mp="15347ep58kp95">
                <h3 className="font-display text-[22px] font-bold uppercase leading-[1.05] text-navy" data-id="element-193" data-mp="112c041fxcufi">{w.title}</h3>
                <p className="mt-2 text-sm text-ink/80" data-id="element-194" data-mp="w4sjiuvr85ke">{w.text}</p>
              </div>
            </li>)}
        </ol>
        <div className="mt-12 text-center" data-id="element-195" data-mp="2vg3efe9782ha">
          <CtaButton href="#offer-details" className="w-full sm:w-auto" data-id="element-196" data-mp="2qh8n1nx615lk">
            Get all 10 workshops
          </CtaButton>
        </div>
      </div>
    </section>;
}